import { CampaignTemplateType } from '@/app/module/campaigns/types'

const quotaSupportedCampaignTypes = new Set<CampaignTemplateType>([
  CampaignTemplateType.Drip,
  CampaignTemplateType.Reminder,
  CampaignTemplateType.VoiceSurvey,
])

export const supportsCampaignQuotas = (campaignType: CampaignTemplateType): boolean =>
  quotaSupportedCampaignTypes.has(campaignType)
